module.exports = __webpack_public_path__ + "img/footer_logo.0762eae4.png";